import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { User } from "lucide-react";
import { cn } from "@/lib/utils";

interface ProAvatarProps {
  avatarUrl?: string | null;
  email?: string | null;
  isPro?: boolean;
  isFounder?: boolean;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeClasses = {
  sm: "h-8 w-8",
  md: "h-10 w-10",
  lg: "h-12 w-12",
};

const getInitials = (email: string | null | undefined): string => {
  if (!email) return "?";
  const name = email.split("@")[0];
  return name.substring(0, 2).toUpperCase();
};

export const ProAvatar = ({
  avatarUrl,
  email,
  isPro = false,
  isFounder = false,
  size = "md",
  className,
}: ProAvatarProps) => {
  const showRing = isPro || isFounder;
  const ringClass = isFounder
    ? "ring-2 ring-orange-500"
    : "ring-2 ring-cyan-500";

  return (
    <Avatar className={cn(sizeClasses[size], showRing && ringClass, className)}>
      {avatarUrl ? (
        <AvatarImage src={avatarUrl} alt={email || "User avatar"} />
      ) : (
        <AvatarFallback className="bg-muted text-muted-foreground font-semibold">
          {email ? getInitials(email) : <User className="h-4 w-4" />}
        </AvatarFallback>
      )}
    </Avatar>
  );
};
